import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import Signin from '@/views/User/Signin.vue';
import Signup from '@/views/User/Signup.vue';
import Main from '@/views/Common/Main.vue';

import Contract from '@/views/Contract/Contract.vue';
import ContractDetail from '@/views/Contract/Detail.vue';
import ContractCompletion from '@/views/Contract/Completion.vue';


import Reception from '@/views/Reception/Reception.vue';
import ReceptionDetail from '@/views/Reception/Detail.vue';
import ReceptionCompletion from '@/views/Reception/Completion.vue';
import Sample from '@/views/Sample/Sample.vue';

import Experiment from '@/views/Experiment/Experiment.vue';
import ExperimentDetail from '@/views/Experiment/Detail.vue';
import ExperimentCompletion from '@/views/Experiment/Completion.vue';

import Company from '@/views/Management/Company/Company.vue'
import CompanyDetail from "@/views/Management/Company/Detail.vue";
import User from "@/views/Management/User/User.vue";
import UserDetail from "@/views/Management/User/Detail.vue";
import Department from "@/views/Management/Department/Department.vue";
import Menu from "@/views/Management/Menu/Menu.vue";
import Sheet from "@/views/Management/Sheet/Sheet.vue";
import Code from "@/views/Management/Code/Code.vue";
import Authority from "@/views/Management/Authority/Authority.vue";

import Plating from '@/views/Sequencing/Plating/Plating.vue'
import PlatingDetail from '@/views/Sequencing/Plating/Detail.vue'
import PlatingCompletion from '@/views/Sequencing/Plating/Completion.vue'
import RunInfo from "@/views/Sequencing/RunInfo/RunInfo.vue";
import Demultiplex from "@/views/Sequencing/Demultiplex/Demultiplex.vue";
import Equipment from "@/views/Sequencing/Equipment/Equipment.vue";
import EquipmentDetail from '@/views/Sequencing/Equipment/Detail.vue'

import Pipeline from "@/views/Analysis/Pipeline/Pipeline.vue";
import PipelineDetail from '@/views/Analysis/Pipeline/Detail.vue';
import PipelineTask from '@/views/Analysis/Pipeline/PipelineTask.vue';
import PipelineTaskDetail from '@/views/Analysis/Pipeline/TaskDetail.vue';

import Result from "@/views/Result/Result.vue";
import ResultDetail from '@/views/Result/Detail.vue'

import Order from '@/views/Order/Order.vue';
import OrderDetail from '@/views/Order/Detail.vue';
import OrderCompletion from '@/views/Order/Completion.vue';
import OrderConfirm from '@/views/OrderConfirmation/OrderConfirm.vue';
import OrderConfirmDetail from '@/views/OrderConfirmation/Detail.vue';
import OrderConfirmCompletion from '@/views/OrderConfirmation/Completion.vue';

import Microbiome from "@/views/Analysis/Microbiome/Microbiome.vue";
import Editor from "@/views/Common/Editor.vue";

import Pdf from "@/views/ex-api/Pdfauth.vue";


const requireAuth = () => (from, to, next) => {
    if (store.getters.isAuthenticated) return next();
    next('/?returnPath=list');
};
Vue.prototype.$router = Router;
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
            path: "/",
            name: "Signin",
            component: Signin
        },
        {
            path: "/signup",
            name: "Signup",
            component: Signup
        },
        {
            path: '/main',
            name: 'main',
            component: Main,
            beforeEnter: requireAuth()
        },
        {
            path: "/contract",
            name:"contract",
            component: Contract,

            beforeEnter: requireAuth()
        },
        {
            path: "/contract/detail",
            name:"contract_detail",
            component: ContractDetail,

            beforeEnter: requireAuth()
        },
        {
            path: "/contract/completion",
            name:"contract_completion",
            component: ContractCompletion,

            beforeEnter: requireAuth()
        },
        {
            path: "/reception",
            name: "receptions",
            component: Reception,
            
            beforeEnter: requireAuth()
        },
        {
            path: "/reception/detail",
            name: "receptions_detail",
            component: ReceptionDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/reception/completion",
            name: "receptions_completion",
            component: ReceptionCompletion,
            beforeEnter: requireAuth()
        },
        {
            path: "/sample",
            name: "samples",
            component: Sample,
            beforeEnter: requireAuth()
        },
        {
            path: '/plating',
            name: 'platinges',
            component: Plating,
            beforeEnter: requireAuth()
        },
        {
            path: "/plating/detail",
            name: "platinges_detail",
            component: PlatingDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/plating/completion",
            name: "platinges_completion",
            component: PlatingCompletion,
            beforeEnter: requireAuth()
        },
        {
            path: "/runinfo",
            name: "runinfoes",
            component: RunInfo,
            beforeEnter: requireAuth()
        },
        {
            path: "/equipment",
            name: "equipments",
            component: Equipment,
            beforeEnter: requireAuth()
        },
        {
            path: "/equipment/detail",
            name: "equipments_detail",
            component: EquipmentDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/demultiplex",
            name: "demultis",
            component: Demultiplex,
            beforeEnter: requireAuth()
        },
        {
            path: "/micro",
            name: "micro",
            component: Microbiome,
            beforeEnter: requireAuth()
        },
        {
            path: "/pipeline",
            name: "pipelines",
            component: Pipeline,
            beforeEnter: requireAuth()
        },
        {
            path: "/pipeline/detail",
            name: "pipelines_detail",
            component: PipelineDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/pipelinetask",
            name: "pipelinetask",
            component: PipelineTask,
            beforeEnter: requireAuth()

        },
        {
            path: "/PipelineTaskDetail",
            name: "pipelinetask_detail",
            component: PipelineTaskDetail,
            beforeEnter: requireAuth()

        },
        {
            path: "/result/detail",
            name: "results_detail",
            component: ResultDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/result/:task",
            name: "results",
            component: Result,
            beforeEnter: requireAuth()
        },
        {
            path: "/order",
            name: "orders",
            component: Order,
            beforeEnter: requireAuth()
        },
        {
            path: "/order/detail",
            name: "orders_detail",
            component: OrderDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/order/completion",
            name: "orders_completion",
            component: OrderCompletion,
            beforeEnter: requireAuth()
        },
        {
            path: '/orderconfirm',
            name: 'orderconfirms',
            component: OrderConfirm,
            beforeEnter: requireAuth()
        },
        {
            path: '/orderconfirm/detail',
            name: 'orderconfirms_detail',
            component: OrderConfirmDetail,
            beforeEnter: requireAuth()
        },
        {
            path: '/orderconfirm/completion',
            name: 'orderconfirms_completion',
            component: OrderConfirmCompletion,
            beforeEnter: requireAuth()
        },
        {
            path: "/company",
            name: "companies",
            component: Company,
            beforeEnter: requireAuth()
        },
        {
            path: "/company/detail",
            name: "companies_detail",
            component: CompanyDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/user",
            name: "users",
            component: User,
            beforeEnter: requireAuth()
        },
        {
            path: "/user/detail",
            name: "users_detail",
            component: UserDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/department",
            name: "departments",
            component: Department,
            beforeEnter: requireAuth()
        },
        {
            path: "/code",
            name: "codes",
            component: Code,
            beforeEnter: requireAuth()
        },
        {
            path: "/menu",
            name: "menus",
            component: Menu,
            beforeEnter: requireAuth()
        },
        {
            path: "/sheet",
            name: "sheets",
            component: Sheet,
            beforeEnter: requireAuth()
        },
        {
            path: "/authority",
            name: "authorities",
            component: Authority,
            beforeEnter: requireAuth()
        },
        {
            path: "/editor",
            name: "editor",
            component: Editor,
            beforeEnter: requireAuth()
        },
        {
            path: "/exapi",
            name: "exapi",
            component: Pdf,
        },
        {
            path: '/:mid',
            name: 'experiments',
            component: Experiment,
            beforeEnter: requireAuth()
        },
        {
            path: "/experiment/detail",
            name: "experiments_detail",
            component: ExperimentDetail,
            beforeEnter: requireAuth()
        },
        {
            path: "/experiment/completion",
            name: "experiments_completion",
            component: ExperimentCompletion,
            beforeEnter: requireAuth()
        },
       
    ]
});



// WEBPACK FOOTER //
// ./src/routes/index.js